import React from "react";
import Icon from "components/CommonIcon/Icon";

const DrawerHead = ({ title, onClose }) => {
  return (
    <div className="bg-white w-full p-16 relative border-b border-gray-border">
      <div
        className="absolute top-20 left-20 cursor-pointer z-1"
        onClick={onClose}>
        <Icon name="close" fontSize="text-16" />
      </div>
      <h3 className="font-semibold text-h5 text-gray-text text-center relative p-2">
        {title}
      </h3>
    </div>
  );
};

export default DrawerHead;
